import { render } from "./DefButtonSecondary.vue?vue&type=template&id=7249641a&scoped=true"
import script from "./DefButtonSecondary.vue?vue&type=script&lang=js"
export * from "./DefButtonSecondary.vue?vue&type=script&lang=js"

import "./DefButtonSecondary.vue?vue&type=style&index=0&id=7249641a&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7249641a"]])

export default __exports__